import React from 'react';
import { Presentation } from './components/Presentation';
export function App() {
  return <Presentation data-id="element-0" data-mp="35ck9i4xooyhx" />;
}